export default __webpack_public_path__ + "static/vodafone-color.url-fc8970cba2afccf1d3b8c5583e79e207.svg";